import * as React from 'react';
import { observer } from 'mobx-react';
import { configConsumer, ServiceView } from '@estee/elc-service';
import { CONTENT_BLOCK } from '@estee/elc-service-view-names';

interface IVtoFoundationQrCodeOverlay {
    config: {
        contentServiceNodeIds: {
            vtoFoundationQrCodeOverlay: number;
        };
    };
}

const { name: serviceName } = __serviceInfo__;

export const VtoFoundationQrCodeOverlay = configConsumer(['contentServiceNodeIds'])(
    observer(({ config }: IVtoFoundationQrCodeOverlay) => {
        const {
            contentServiceNodeIds: { vtoFoundationQrCodeOverlay: nid }
        } = config;

        return <ServiceView name={CONTENT_BLOCK} config={{ nid }} serviceName={serviceName} />;
    })
);
